import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE_URL, seoForPath } from "@/lib/seo-config";

/** Per-route title, description, canonical and social tags. */
const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = seoForPath(pathname);
  const url = `${SITE_URL}${seo.path === "/" ? "/" : seo.path}`;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
};

export default RouteSeo;
